import React, { useState } from "react";
import { LogoUploadDialog } from "../../..";
import { usePrimaryOrganizationId } from "../../../../hooks/useOrganization";
import { ACCEPTED_FILE_TYPES } from "../../../dialog/LogoUploadDialog";
import { SettingRow } from "./SettingRow";
import { Button } from "@truevault/aquilo";
import { XMarkIcon } from "@heroicons/react/24/solid";
import clsx from "clsx";

type Props = {
  headerImageUrl: string;
  updateMessageSettings: ({ logoUrl }) => void;
  vertical?: boolean;
};

const helpText =
  "This logo will be displayed at the top of your emails. Logo in .png or .jpg preferred; maximum file size is 1MB; max height of 100px";

export const EmailLogoSettingRow: React.FC<Props> = ({
  headerImageUrl,
  updateMessageSettings,
  vertical = false,
}) => {
  const orgId = usePrimaryOrganizationId();
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <>
      <SettingRow title="Email Logo" helpText={helpText} vertical={vertical}>
        <div className="tw-boundary">
          <div className="flex items-start">
            <div className="mr-[32px]">
              <Button
                color={headerImageUrl ? "tertiary" : "primary"}
                onClick={() => setDialogOpen(true)}
              >
                {headerImageUrl ? "Change Logo" : "Upload"}
              </Button>
            </div>

            {headerImageUrl && (
              <div className="relative">
                <img src={headerImageUrl} className="max-w-[192px] max-h-[192px]" />
                <div
                  className={clsx(
                    "w-[30px] h-[30px] p-[10px]",
                    "rounded-[17px] border border-solid border-neutral-300 bg-white",
                    "absolute top-[-10px] right-[-10px] z-10",
                    "grid place-items-center",
                    "cursor-pointer",
                  )}
                  onClick={() => updateMessageSettings({ logoUrl: "" })}
                >
                  <XMarkIcon className="h-[10px] w-[10px] text-neutral-500" />
                </div>
              </div>
            )}
          </div>
        </div>
        <LogoUploadDialog
          acceptedTypes={ACCEPTED_FILE_TYPES}
          logoType="MESSAGE_HEADER"
          title="Upload Email Header Logo"
          organizationId={orgId}
          open={dialogOpen}
          onClose={() => setDialogOpen(false)}
          onDone={(logoUrl: string) => updateMessageSettings({ logoUrl })}
          successMessage={undefined}
        />
      </SettingRow>
    </>
  );
};
